import React from 'react';

// One icon button in the 64px rail. Plain-JS .tsx (no type annotations).
export default function NavRailIcon({ icon, title, active, onClick, onMouseEnter }) {
  return (
    <button
      type='button'
      className={`nav-ico${active ? ' active' : ''}`}
      title={title}
      aria-label={title}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
    >
      <i className={icon} />
    </button>
  );
}
